import React from 'react';
import css from './CSS/mobile.css';

const Mobile = () => {
    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#06002fff' }}>
            <div style={{ position: 'relative', width: '100%' }}>
                <a
                    href="https://www.schoolwave.in"
                    style={{
                        position: 'absolute',
                        top: '20px',
                        left: '20px',
                        padding: '10px 20px',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        color: '#000',
                        textDecoration: 'none',
                        borderRadius: '5px',
                        fontWeight: 'bold',
                        zIndex: 10,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}
                >
                    &larr; Back
                </a>
                <img
                    src="/01.jpeg"
                    alt="Mobile 01"
                    style={{ width: '100%', height: '750px', display: 'block', objectFit: 'contain' }}
                />
            </div>
            <img
                src="/02.jpeg"
                alt="Mobile 02"
                style={{ width: '100%', height: '750px', display: 'block', objectFit: 'contain' }}
            />
            <img
                src="/03.jpeg"
                alt="Mobile 03"
                style={{ width: '100%', height: '750px', display: 'block', objectFit: 'contain' }}
            />
            <img
                src="/04.jpeg"
                alt="Mobile 04"
                style={{ width: '100%', height: '750px', display: 'block', objectFit: 'contain' }}
            />
        </div>
    );
};

export default Mobile;
